import React from 'react';
import { humanize } from 'underscore.string';

import Badge from 'components/v2/Badge';
import { useTranslation } from 'react-i18next';

const STATUS_MAP = {
  approved: 'green',
  canceled: 'grey',
  declined: 'red',
  pending: 'blue',
  missed: 'yellow',
  complete: 'purple',
};

/*
 * An appointment status table cell component
 */
export default function AppointmentStatusTableCell({ status }) {
  const color = STATUS_MAP[status] || 'grey';
  const { t } = useTranslation();

  return <Badge color={color}>{humanize(t(status.toUpperCase()))}</Badge>;
}
